export const minifyScript = (script: string) => {
  if (typeof script !== "string") return script;
  return script
    .replace(/\n/g, "") // Remove newlines
    .replace(/\s+/g, " ") // Replace multiple spaces with a single space
    .replace(/\s*([{}()[\];=,+\-*/%&|^!<>?:])\s*/g, "$1") // Remove spaces around symbols
    .replace(/;}/g, "}") // Remove semicolons before closing braces
    .replace(/,\)}/g, ")"); // Remove commas before closing parentheses
};
